module.exports = __webpack_public_path__ + "static/img/yg1.4cd3b7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/yg1.png
// module id = UenL
// module chunks = 7